/**
 * Non-blocking wrapper around `navigator.geolocation.getCurrentPosition`.
 *
 * Resolves to `{ lat, lng, accuracy }` when the browser gives us a location
 * within `timeoutMs` (default 4s), or `null` when geolocation is unavailable,
 * denied, or times out. Never rejects — callers can `await` and ignore null.
 */
export function getCurrentLocation(timeoutMs = 4000) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve(null);
      return;
    }
    let settled = false;
    const done = (v) => {
      if (settled) return;
      settled = true;
      resolve(v);
    };
    const timer = setTimeout(() => done(null), timeoutMs);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timer);
        done({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        });
      },
      () => { clearTimeout(timer); done(null); },
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 15000 },
    );
  });
}
